export default function getLanguageCode() {
  return Shopify.locale.toUpperCase().replaceAll('-', '_');
}